import "./Channel.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import partnersApi from "../../apis/Partners.api";
import GroupBuyingModal from "../../components/channel/GroupBuyingModal";
import EventComponent from "../../components/channel/home/EventComponent";
import HomeBanner from "../../components/channel/home/HomeBanner";
import HomeChemist from "../../components/channel/home/HomeChemist";
import HomeCommunity from "../../components/channel/home/HomeCommunity";
import HomeFaq from "../../components/channel/home/HomeFaq";
import HomeHotKeyword from "../../components/channel/home/HomeHotKeyword";
// import HomeGroupBuying from "../../components/channel/home/HomeGroupBuying";
import HomeMention from "../../components/channel/home/HomeMention";
import HomeRecommendHorizontal from "../../components/channel/home/HomeRecommendHorizontal";
import HomeRecommendVertical from "../../components/channel/home/HomeRecommendVertical";
import NowGroupBuying from "../../components/channel/home/NowGroupBuying";

const Home = () => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const [combiList, setCombiList] = useState([]);
	const [ingreList, setIngreList] = useState([]);
	const [funcList, setFuncList] = useState([]);

	const [nowList, setNowList] = useState([]);
	const [readyList, setReadyList] = useState([]);

	const [alertShow, setAlertShow] = useState(false);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		if (reduxChannel?.user_id) {
			getCategory();
			getGroupBuying();
		}
	}, [reduxChannel, mediaResult]);

	/**
	 * 홈화면 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategory = async () => {
		let param = {
			offset: 0,
			pageSize: mediaResult ? 6 : 8,
			// pageSize: 8,
			categoryType: "home",
			influencerId: reduxChannel.user_id,
		};
		const res = await partnersApi.togetherCategoryRead(param);
		if (res.code === 200) {
			let combi = res.result?.recommendCombinationList?.map((item) => ({
				...item,
				bg_color:
					reduxChannel?.user_id === 7
						? item.is_hot
							? "#fe2b4b"
							: item.is_best
							? "#ff8000"
							: reduxChannel?.color_2
							? reduxChannel?.color_2
							: null
						: item.is_hot
						? "#FF8000"
						: item.is_best
						? "#005DA9"
						: reduxChannel?.color_2
						? reduxChannel?.color_2
						: null,
				// bg_color: item.is_hot ? "#fe2b4b" :
				//     item.is_best ? "#ff8000" :
				//         reduxChannel?.color_1 ? reduxChannel?.color_1 : "#272847"
			}));
			let ingre = res.result?.ingredientList?.map((item) => ({
				...item,
				bg_color:
					reduxChannel?.user_id === 7
						? item.is_hot
							? "#fe2b4b"
							: item.is_best
							? "#ff8000"
							: reduxChannel?.color_2
							? reduxChannel?.color_2
							: null
						: item.is_hot
						? "#FF8000"
						: item.is_best
						? "#005DA9"
						: reduxChannel?.color_2
						? reduxChannel?.color_2
						: null,
				// bg_color: item.is_hot ? "#fe2b4b" :
				//     item.is_best ? "#ff8000" :
				//         reduxChannel?.color_2 ? reduxChannel?.color_2 : "#272847"
			}));
			let func = res.result?.functionList?.map((item) => ({
				...item,
				bg_color:
					reduxChannel?.user_id === 7
						? item.is_hot
							? "#fe2b4b"
							: item.is_best
							? "#ff8000"
							: reduxChannel?.color_2
							? reduxChannel?.color_2
							: null
						: item.is_hot
						? "#FF8000"
						: item.is_best
						? "#005DA9"
						: reduxChannel?.color_2
						? reduxChannel?.color_2
						: null,
				// bg_color: item.is_hot ? "#fe2b4b" :
				//     item.is_best ? "#ff8000" :
				//         reduxChannel?.color_1 ? reduxChannel?.color_1 : "#272847"
			}));
			setCombiList(combi);
			setIngreList(ingre);
			setFuncList(func);
		}
	};

	/**
	 * 공동 구매 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getGroupBuying = async () => {
		let param = {
			influencerId: reduxChannel?.user_id,
			// influencerId: 1
		};
		const res = await partnersApi.readGroupBuyingList(param);
		if (res.code === 200) {
			// console.log(res.result.ongoingCooperateList);
			// console.log(res.result.predestinationCooperateList);
			// setNowList(res.result.predestinationCooperateList);
			setNowList(res.result.ongoingCooperateList);
			setReadyList(res.result.predestinationCooperateList);
		}
	};

	if (reduxChannel?.influencer_id) {
		return (
			<div className={`channel-wrap channel-home channel-delay`}>
				{/* 홈 화면 배너 */}
				{reduxChannel?.user_id !== 9 && <HomeBanner />}

				{reduxChannel?.user_id === 9 && (
					<EventComponent setAlertShow={setAlertShow} />
				)}
				{/* 링크 연결 */}
				{/*<HomeLinkConnection/>*/}
				{/*<GroupBuyingHardCoding*/}
				{/*    setAlertShow={setAlertShow}*/}
				{/*/>*/}

				{/*현재 진행중인 공동구매 */}
				{reduxChannel?.user_id !== 9 && (
					<NowGroupBuying
						nowList={nowList}
						readyList={readyList}
						setAlertShow={setAlertShow}
						type={"now"}
					/>
				)}

				{/* 공동구매 진행 예정 */}
				{reduxChannel?.user_id !== 9 && (
					<NowGroupBuying
						nowList={readyList}
						setAlertShow={setAlertShow}
						type={"ready"}
					/>
				)}

				{/* 인기 검색어 */}
				{!!reduxChannel?.topSearchedList?.length && <HomeHotKeyword />}

				{/* 소통 */}
				{reduxChannel?.user_id === 9 && <HomeCommunity />}

				{/* 채널 한마디 */}
				{reduxChannel?.user_id !== 9 && (
					<HomeChemist nowList={nowList} readyList={readyList} />
				)}
				{/*{reduxChannel?.user_id === 7 && (*/}
				{/*	<HomeChemist nowList={nowList} readyList={readyList} />*/}
				{/*)}*/}
				{/*<ReadyGroupBuying*/}
				{/*    nowList={nowList}*/}
				{/*    readyList={readyList}*/}
				{/*    setAlertShow={setAlertShow}*/}
				{/*/>*/}

				{/* 공동구매 마감 알림 */}
				{/*<DoneGroupBuying*/}
				{/*    nowList={nowList}*/}
				{/*    readyList={readyList}*/}
				{/*    setAlertShow={setAlertShow}*/}
				{/*/>*/}

				{/* 공구 이벤트 */}
				{/*<GroupBuyingEvent/>*/}

				{/* 가장 많이 물어보는 질문 */}
				<HomeFaq />

				{/* 조합별 */}
				{reduxChannel?.combination_menu_show && (
					<HomeRecommendVertical
						type={"combination"}
						categoryList={combiList}
					/>
				)}

				{/* 성분별 */}
				{reduxChannel?.ingredient_menu_show && (
					<HomeRecommendHorizontal
						type={"ingredient"}
						categoryList={ingreList}
					/>
				)}

				{/* 고민별 */}
				{reduxChannel?.function_menu_show && (
					<HomeRecommendVertical type={"function"} categoryList={funcList} />
				)}

				{/* 한마디 */}
				{/*{reduxChannel?.user_id !== 7 && <HomeMention />}*/}

				{/* 공구 알림 받기 - modal */}
				{alertShow && (
					<GroupBuyingModal alertShow={alertShow} setAlertShow={setAlertShow} />
				)}
			</div>
		);
	} else {
		return <></>;
	}
};
export default Home;
